"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ON_FILING = exports.WAIVER = exports.INSTALLMENTS = void 0;
var INSTALLMENTS = 'installments';
exports.INSTALLMENTS = INSTALLMENTS;
var WAIVER = 'waiver';
exports.WAIVER = WAIVER;
var ON_FILING = 'on_filing';
exports.ON_FILING = ON_FILING;